import { Component } from '@theme/component';
import { deliveryPageContent } from '@theme/bt-delivery-page-content';

/**
 * Delivery page — live production copy (not PDP metaobjects).
 *
 * @extends {Component}
 */
class BtDeliveryPage extends Component {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    super.connectedCallback();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    const select = this.querySelector('[data-bt-delivery-select]');
    const panels = this.querySelector('[data-bt-delivery-panels]');
    if (!(select instanceof HTMLSelectElement) || !(panels instanceof HTMLElement)) return;

    const initial = this.dataset.defaultCountry || 'uk';
    if (deliveryPageContent[initial]) {
      select.value = initial;
    }

    this.#renderCountry(panels, select.value || 'uk');
    select.addEventListener('change', () => this.#renderCountry(panels, select.value), { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /**
   * @param {HTMLElement} panels
   * @param {string} countryKey
   */
  #renderCountry(panels, countryKey) {
    const country = deliveryPageContent[countryKey];
    panels.replaceChildren();
    if (!country) return;

    const grid = document.createElement('div');
    grid.className = 'bt-delivery-page__cards';

    for (const item of country.items) {
      if (!item.title && !item.html) continue;

      const card = document.createElement('article');
      card.className = 'bt-delivery-page__card';

      if (item.title) {
        const title = document.createElement('h3');
        title.className = 'bt-delivery-page__card-title text-p2-bold color-text-primary';
        title.textContent = item.title;
        card.appendChild(title);
      }

      if (item.html) {
        const body = document.createElement('div');
        body.className = 'bt-delivery-page__card-body text-p3 color-text-primary';
        body.innerHTML = item.html;
        card.appendChild(body);
      }

      grid.appendChild(card);
    }

    panels.appendChild(grid);
  }
}

if (!customElements.get('bt-delivery-page')) {
  customElements.define('bt-delivery-page', BtDeliveryPage);
}
